export default [
    {
        field: 'accounting_bank_card_chile_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            disabled: true,
            label: 'Cartola de banco',
        },
        options: {
            data: [],
            text: 'document_number',
            value: 'id',
        },
        readonly: true,
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'g_user_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            disabled: true,
            label: 'Responsable',
        },
        options: {
            data: [],
            text: g_user => g_user.hr_employee.names + ' ' + g_user.hr_employee.last_name1 + ' ' + g_user.hr_employee.last_name2,
            value: 'id',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'branch_office',
        type: 'text',
        vuetifyProps: {
            label: 'Sucursal',
        },
        readonly: true,
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'movement_detail',
        type: 'text',
        vuetifyProps: {
            label: 'Tipo',
        },
        readonly: true,
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'deposit',
        type: 'text',
        vuetifyProps: {
            label: 'Deposito',
        },
        readonly: true,
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'balance',
        type: 'text',
        vuetifyProps: {
            label: 'Balance',
        },
        readonly: true,
        rules: [ 'required' ],
        value: '',
    },
]